import React, {useEffect, useState} from 'react';
import {
    GuaranteeCard, RentForm,
    PriceCard,
    ProductDescription,
    ProductDetailHeader,
    ProductImage,
    ProductTitle, SpecificationsCard, StorageAndDeliveryConditionsCard
} from "../../components";
import {Divider, Flex, Skeleton} from "antd";
import Alert from "../../components/ProductDetailContent/Alert";
import RentFormPopUp from "../../components/ProductDetailContent/rentFormPopUp/RentFormPopUp";
import {connect} from "react-redux";
import {getProductThumbnail} from "../../../../shared";
import {withRouter} from "../../../../utils/services/with-router";
import {getProductDetail} from "../../actions/Product.action";
import {ProductDetailProps} from "../../models";
import {useParams} from "react-router-dom";

const ProductDetail = ({getProductDetail} : ProductDetailProps) => {
    const { id } = useParams();
    const [product, setProduct] =
        useState<any>();
    const [loading, setLoading] =
        useState<boolean>(false);

    const _getProductThumbnail = () => {
        setLoading(true);
        getProductDetail(id)
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {

                    setProduct(data.payload.data);

                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getProductThumbnail();
    }, []);
    return (


                 <Flex vertical justify={"center"} gap={"small"}>
                <ProductDetailHeader bookmarked={product?.isBookmarked}/>
               <Flex vertical justify={"center"} gap={"small"} style={{marginTop: "60px"}}>
                   <ProductImage product={product}/>


                   {loading ? <Flex vertical gap={"large"}>
                           <Skeleton active/>
                           <Skeleton.Input active={true} size={"small"} block />
                           <Skeleton.Input active={true} size={"small"} block />
                           <Skeleton.Input active={true} size={"small"} block />
                           <Skeleton.Input active={true} size={"small"} block />

                       </Flex> :
                       <Flex vertical justify={"center"} gap={"small"} >
                           <ProductTitle product={product}/>
                           <ProductDescription product={product}/>
                           <PriceCard product={product?.productPricings}/>
                           <GuaranteeCard product={product}/>
                           <SpecificationsCard product={product}/>
                           <StorageAndDeliveryConditionsCard product={product}/>
                       </Flex>}

                   <Alert/>
                   {loading ? <Flex gap={"small"}>
                           <Skeleton.Button active={true} size={"large"} block />



                       </Flex> :
                       <RentForm product={product}/>}
               </Flex>

            </Flex>

    );
};

export default connect(null, {getProductDetail})(withRouter(ProductDetail));
